var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-card",
        { staticClass: "mb5" },
        [
          _c(
            "el-form",
            {
              attrs: { inline: false, "label-position": "top", size: "small" },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 7 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "timeType" } },
                        [
                          _c("template", { slot: "label" }, [
                            _c(
                              "div",
                              { staticClass: "selectLabel" },
                              [
                                _c(
                                  "el-select",
                                  {
                                    style: _vm.IsWidth01,
                                    model: {
                                      value: _vm.queryForm.params.timeType,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryForm.params,
                                          "timeType",
                                          $$v
                                        )
                                      },
                                      expression: "queryForm.params.timeType",
                                    },
                                  },
                                  [
                                    _c("el-option", {
                                      key: "1",
                                      attrs: {
                                        label: _vm.$t("fixDutyFine.reportTime"),
                                        value: 1,
                                      },
                                    }),
                                    _c("el-option", {
                                      key: "2",
                                      attrs: {
                                        label: _vm.$t(
                                          "fixDutyFine.approvalTime"
                                        ),
                                        value: 2,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              clearable: false,
                              "default-time": ["00:00:00", "23:59:59"],
                              format:
                                _vm.$i18n.locale == "zh"
                                  ? _vm.zhDate
                                  : _vm.ptDate,
                              placeholder: _vm.$t("newOrder.SelectDatetime"),
                              "range-separator": "~",
                              type: "datetimerange",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                            },
                            model: {
                              value: _vm.timeValue,
                              callback: function ($$v) {
                                _vm.timeValue = $$v
                              },
                              expression: "timeValue",
                            },
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("fixDutyFine.eventType") } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { clearable: "" },
                              model: {
                                value: _vm.queryForm.params.eventType,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryForm.params,
                                    "eventType",
                                    $$v
                                  )
                                },
                                expression: "queryForm.params.eventType",
                              },
                            },
                            [
                              _c("el-option", {
                                key: "1",
                                attrs: {
                                  label: _vm.$t("fixDutyFine.abnormalEvent"),
                                  value: 1,
                                },
                              }),
                              _c("el-option", {
                                key: "2",
                                attrs: {
                                  label: _vm.$t("fixDutyFine.theftEvent"),
                                  value: 2,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("fixDutyFine.abnormalityType"),
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { filterable: "", multiple: "" },
                              model: {
                                value: _vm.queryForm.params.exceptionTypeList,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryForm.params,
                                    "exceptionTypeList",
                                    $$v
                                  )
                                },
                                expression:
                                  "queryForm.params.exceptionTypeList",
                              },
                            },
                            _vm._l(_vm.exceptionTypeList, function (item) {
                              return _c("el-option", {
                                key: item.type,
                                attrs: {
                                  label: item.typeName,
                                  value: item.type,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("GlobalSetObj.status") } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { multiple: "" },
                              model: {
                                value: _vm.queryForm.params.approveStatusList,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryForm.params,
                                    "approveStatusList",
                                    $$v
                                  )
                                },
                                expression:
                                  "queryForm.params.approveStatusList",
                              },
                            },
                            [
                              _c("el-option", {
                                key: "1",
                                attrs: {
                                  label: _vm.$t("fixDutyFine.pendingApproval"),
                                  value: 0,
                                },
                              }),
                              _c("el-option", {
                                key: "2",
                                attrs: {
                                  label: _vm.$t("customerManagements.approved"),
                                  value: 1,
                                },
                              }),
                              _c("el-option", {
                                key: "3",
                                attrs: {
                                  label: _vm.$t("home.unapplivefail"),
                                  value: 2,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 5 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("fixDutyFine.reportingRegion"),
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t("placeOrder.pleaseChoose"),
                                clearable: "",
                                filterable: "",
                              },
                              model: {
                                value: _vm.queryForm.params.regionId,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryForm.params,
                                    "regionId",
                                    $$v
                                  )
                                },
                                expression: "queryForm.params.regionId",
                              },
                            },
                            _vm._l(_vm.regionList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: {
                                  label:
                                    item.zhName + "（" + item.puName + "）",
                                  value: item.id,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 5 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("fixDutyFine.reportingPersonnel"),
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "GlobalSetObj.pleaseChoose"
                                ),
                                "remote-method": _vm.getCustomerPage,
                                clearable: "",
                                filterable: "",
                                remote: "",
                                "reserve-keyword": "",
                              },
                              on: { "visible-change": _vm.handleVisibleChange },
                              model: {
                                value: _vm.queryForm.params.reportUser,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryForm.params,
                                    "reportUser",
                                    $$v
                                  )
                                },
                                expression: "queryForm.params.reportUser",
                              },
                            },
                            _vm._l(_vm.userList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.username, value: item.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 5 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("GlobalSetObj.client") } },
                        [
                          _c("ElSelectV2", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              options: _vm.customerList,
                              placeholder: _vm.$t("placeOrder.pleaseChoose"),
                              clearable: "",
                              filterable: "",
                              multiple: "",
                              "collapse-tags": "",
                            },
                            on: { change: _vm.changeCus },
                            model: {
                              value: _vm.queryForm.params.customerIdList,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.queryForm.params,
                                  "customerIdList",
                                  $$v
                                )
                              },
                              expression: "queryForm.params.customerIdList",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 5 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("collectionCenter.CommercialOwner"),
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t("placeOrder.pleaseChoose"),
                                clearable: "",
                                filterable: "",
                                multiple: "",
                                "collapse-tags": "",
                                remote: "",
                                "reserve-keyword": "",
                                "remote-method": _vm.remoteMethod,
                              },
                              on: { "visible-change": _vm.getShanghuList },
                              model: {
                                value: _vm.queryForm.params.merchantCodeList,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryForm.params,
                                    "merchantCodeList",
                                    $$v
                                  )
                                },
                                expression: "queryForm.params.merchantCodeList",
                              },
                            },
                            _vm._l(_vm.merchantList, function (item, idx) {
                              return _c("el-option", {
                                key: idx,
                                attrs: { label: item.name, value: item.code },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("el-col", { attrs: { span: 6 } }, [
                    _c(
                      "div",
                      { staticStyle: { "margin-top": "28px" } },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              icon: "el-icon-search",
                              size: "small",
                              type: "primary",
                            },
                            on: { click: _vm.enterSearch },
                          },
                          [_vm._v(_vm._s(_vm.$t("newOrder.search")) + " ")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              icon: "el-icon-refresh-left",
                              size: "small",
                              type: "info",
                            },
                            on: { click: _vm.resetForm },
                          },
                          [_vm._v(_vm._s(_vm.$t("newOrder.reset")) + " ")]
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        [
          _c(
            "div",
            { staticStyle: { "margin-bottom": "10px" } },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "permit",
                      rawName: "v-permit:remove",
                      value: "btn:exceptionReporting:reportedEvent",
                      expression: "'btn:exceptionReporting:reportedEvent'",
                      arg: "remove",
                    },
                  ],
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.clickEvent },
                },
                [_vm._v(_vm._s(_vm.$t("fixDutyFine.reportedEvent")) + " ")]
              ),
              _c(
                "el-button",
                { attrs: { size: "small" }, on: { click: _vm.allExportOrder } },
                [_vm._v(_vm._s(_vm.$t("newOrder.export")))]
              ),
              _c(
                "el-button",
                { attrs: { size: "small" }, on: { click: _vm.exportMsg } },
                [_vm._v(_vm._s(_vm.$t("collectionCenter.exportDetails")))]
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                "header-cell-style": { background: "#f2f2f2", color: "black" },
                border: "",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("GlobalSetObj.serial"),
                  align: "center",
                  fixed: "left",
                  type: "index",
                  width: "80",
                },
              }),
              _vm._l(_vm.tableHeaderList, function (item, index) {
                return _c("el-table-column", {
                  key: index,
                  attrs: {
                    align: item.cloCenter,
                    label: item.label,
                    "min-width": item.cloWidth,
                    prop: item.prop,
                    "show-overflow-tooltip": true,
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            item.prop === "approveStatus"
                              ? _c(
                                  "div",
                                  [
                                    scope.row.approveStatus === 0
                                      ? _c("el-tag", [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                scope.row.approveStatusName
                                              ) +
                                              " "
                                          ),
                                        ])
                                      : _vm._e(),
                                    scope.row.approveStatus === 1
                                      ? _c(
                                          "el-tag",
                                          { attrs: { type: "success" } },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  scope.row.approveStatusName
                                                ) +
                                                " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    scope.row.approveStatus === 2
                                      ? _c(
                                          "el-tag",
                                          { attrs: { type: "danger" } },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  scope.row.approveStatusName
                                                ) +
                                                " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              : item.prop === "waybillQuantity"
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "verifier",
                                    on: {
                                      click: function ($event) {
                                        return _vm.clickDown(scope.row)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(scope.row.waybillQuantity) +
                                        " "
                                    ),
                                  ]
                                )
                              : _c("div", { staticClass: "multiline" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        scope.row[item.prop] !== null
                                          ? "" + scope.row[item.prop]
                                          : "--"
                                      ) +
                                      " "
                                  ),
                                ]),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                })
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("GlobalSetObj.operate"),
                  align: "center",
                  fixed: "right",
                  prop: "varianceNumber",
                  width: "110",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", { staticClass: "flx-around" }, [
                          scope.row.approveStatus !== 1
                            ? _c("i", {
                                directives: [
                                  {
                                    name: "permit",
                                    rawName: "v-permit:remove",
                                    value: "btn:exceptionReporting:toApprove",
                                    expression:
                                      "'btn:exceptionReporting:toApprove'",
                                    arg: "remove",
                                  },
                                ],
                                staticClass:
                                  "iconfont icon-a-ziyuan87 verifier",
                                on: {
                                  click: function ($event) {
                                    return _vm.toApprove(scope.row)
                                  },
                                },
                              })
                            : _vm._e(),
                          _c("i", {
                            staticClass: "iconfont icon-chakan verifier",
                            staticStyle: { "font-size": "22px" },
                            on: {
                              click: function ($event) {
                                return _vm.seeDetail(scope.row)
                              },
                            },
                          }),
                          scope.row.approveStatus !== 1
                            ? _c("i", {
                                directives: [
                                  {
                                    name: "permit",
                                    rawName: "v-permit:remove",
                                    value: "btn:exceptionReporting:toEdit",
                                    expression:
                                      "'btn:exceptionReporting:toEdit'",
                                    arg: "remove",
                                  },
                                ],
                                staticClass: "iconfont icon-a-zu255 verifier",
                                staticStyle: { "font-size": "17px" },
                                on: {
                                  click: function ($event) {
                                    return _vm.toEdit(scope.row)
                                  },
                                },
                              })
                            : _vm._e(),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            2
          ),
          _c("el-pagination", {
            staticStyle: { margin: "10px 0", float: "right" },
            attrs: {
              "current-page": _vm.queryForm.pageNumber,
              "page-size": _vm.queryForm.pageSize,
              "page-sizes": [10, 20, 50, 100],
              total: _vm.queryForm.total,
              background: "",
              layout: "total, sizes, prev, pager, next, jumper",
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _c("reportEvent", {
        ref: "reportEventRef",
        attrs: { "exception-type-list": _vm.exceptionTypeList },
        on: { search: _vm.enterSearch },
      }),
      _c("eventApproval", {
        ref: "eventApprovalRef",
        on: { search: _vm.enterSearch },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }